module.exports = __webpack_public_path__ + "assets/images/JMD100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMD100.png
// module id = 1384
// module chunks = 1